import React from 'react';
import './StarRating.scss';

export interface StarRatingProps {
    value?: number | null;
    max?: number;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    reviewCount?: number;
}

export const StarRating: React.FC<StarRatingProps> = (props) => {
    const { value, max = 5, size = 'md', className = '', reviewCount } = props;
    const normalized =
        value == null || Number.isNaN(Number(value))
            ? 0
            : Math.min(max, Math.max(0, Number(value)));

    const stars = [];
    for (let i = 1; i <= max; i++) {
        const fill =
            normalized >= i ? 1 : normalized > i - 1 ? normalized - (i - 1) : 0;

        if (fill >= 1) {
            stars.push(
                <span key={i} className="star-rating__star star-rating__star--full lnr lnr-star" />
            );
        } else if (fill > 0) {
            stars.push(
                <span
                    key={i}
                    className="star-rating__star star-rating__star--partial"
                    style={{ ['--star-fill' as string]: `${fill * 100}%` }}>
                    <span className="star-rating__partial-bg lnr lnr-star-empty" />
                    <span className="star-rating__partial-fill lnr lnr-star" />
                </span>
            );
        } else {
            stars.push(
                <span key={i} className="star-rating__star star-rating__star--empty lnr lnr-star-empty" />
            );
        }
    }

    return (
        <span
            className={`star-rating star-rating--${size} ${className}`.trim()}
            aria-label={`${normalized} out of ${max} stars`}>
            <span className="star-rating__value">
                {value != null && !Number.isNaN(Number(value))
                    ? Number(value).toFixed(1)
                    : '-'}
            </span>
            {stars}
            {reviewCount != null && reviewCount > 0 && (
                <span className="star-rating__review-count">
                    ({reviewCount})
                </span>
            )}
        </span>
    );
};
